import {
  faFacebook,
  faLinkedin,
  faXTwitter,
} from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { ExternalLink } from "~/components/site/external-link";

type Props = Readonly<{
  title: string;
  url: string;
}>;

const LINKS = [
  {
    href: ({ title, url }: Props) =>
      `https://www.facebook.com/sharer.php?u=${url}&p[title]=${title}`,
    icon: faFacebook,
    label: "Share on Facebook",
  },
  {
    href: ({ title, url }: Props) =>
      `https://twitter.com/share?text=${title}&url=${url}`,
    icon: faXTwitter,
    label: "Share on Twitter",
  },
  {
    href: ({ url }: Props) =>
      `https://www.linkedin.com/sharing/share-offsite/?url=${url}`,
    icon: faLinkedin,
    label: "Share on LinkedIn",
  },
];

export function Share({ title, url }: Props): JSX.Element {
  return (
    <div className="h-fit mb-10">
      <span className="hidden md:block mb-2">Share</span>
      <ul className="flex items-center gap-x-6 m-0 p-0">
        {LINKS.map((l) => {
          const href = l.href({ title, url });
          return (
            <li className="flex items-center gap-x-6 m-0 p-0" key={href}>
              <div className="flex flex-col">
                <div className="flex gap-x-3">
                  <ExternalLink aria-label={l.label} href={href}>
                    <FontAwesomeIcon className="h-5 w-5" icon={l.icon} />
                  </ExternalLink>
                </div>
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
